module.exports = __webpack_public_path__ + "static/media/Mapa-Sergipe.37a0a40b.svg";